<template>

    <datacenter-vserver-list></datacenter-vserver-list>

</template>
<script>

  import DatacenterVserverList from "@/components/datacenter/vserver_datacenter/datacenter-vserver-list";
    export default {
        name: "datacenter-vserver",
        components: {DatacenterVserverList},
        computed:{
            vid(){
                return this.$route.params.id
            }
        },

    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/datacenter/datacenter-vserver.vue